import { ModalMotivosAtencionClaroComponent } from './components/modal-motivos-atencion-claro/modal-motivos-atencion-claro.component';
import { NotificacionService } from './../../core/services/utils/notificacion.service';
import { RutService } from './../../core/services/utils/rut.service';
import { ModalOfflineComponent } from './components/modal-offline/modal-offline.component';
import { ModalErrorComponent } from './components/modal-error/modal-error.component';
import { ColoresService } from './../../core/services/utils/colores.service';
import { ImagesService } from './../../core/services/utils/images.service';
import { ModalAnulacionComponent } from './components/modal-anulacion/modal-anulacion.component';
import { DecryptService } from './../../core/services/utils/decrypt.service';
import { ModalMotivosAtencionComponent } from './components/modal-motivos-atencion/modal-motivos-atencion.component';
import { AtencionService } from './../../core/services/http/atencion.service';
import { Component, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { Router } from '@angular/router';
import { fromEvent, Observable, Subscription } from 'rxjs';
declare var $: any;
import { ServicesService } from './../../core/services/http/services.service';
import { EstadosService } from './../../core/services/http/estados.service';
import { TurnosService } from './../../core/services/http/turnos.service';
import { TimersService } from './../../core/services/utils/timers.service';
import { ConfigService } from './../../core/services/config/config.service';
import { AuthService } from './../../core/services/auth/auth.service';
import { SweetAlertService } from './../../core/services/utils/sweet-alert.service';
import { ModalService } from 'src/app/core/services/utils/modal.service';
import { LocalService } from './../../core/services/storage/local.service';
import { CountersService } from './../../core/services/utils/counters.service';
import { EmitService } from './../../core/services/utils/emit.service';
import { FormatoRutService } from './../../core/services/utils/formato-rut.service';
import { AesService } from 'src/app/core/services/utils/aes.service';
import { ClipboardService } from 'ngx-clipboard'

import { ModalDerivarAtencionComponent } from './components/modal-derivar-atencion/modal-derivar-atencion.component';
import { ModalCerrarSesionComponent } from './components/modal-cerrar-sesion/modal-cerrar-sesion.component';
import { ModalExcepcionFilaComponent } from './components/modal-excepcion-fila/modal-excepcion-fila.component';
import { ModalPausaComponent } from './components/modal-pausa/modal-pausa.component';
import { ModalMotivosPausaComponent } from './components/modal-motivos-pausa/modal-motivos-pausa.component';
import { ModalAtencionRemotaComponent } from './components/modal-atencion-remota/modal-atencion-remota.component';
import { API_ENDPOINT } from 'src/app/core/services/config/config';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { distinctUntilChanged, tap } from 'rxjs/operators';
import { CustomTabletPortrait } from 'src/app/core/utils/utils';
import { ModalDatosUsuarioComponent } from './components/modal-datos-usuario/modal-datos-usuario.component';
import { ModalLlamadoPacienteComponent } from './components/modal-llamado-paciente/modal-llamado-paciente.component';


@Component({
  selector: 'app-llamados',
  templateUrl: './llamados.component.html',
  styleUrls: ['./llamados.component.css']
})
export class LlamadosComponent implements OnInit, OnDestroy {
  //Valores de uso general
  escritorio: any;
  tInicioLlamado: any;
  esperando: any;
  version: any;
  customer: any;
  suscripcion!: Subscription;
  rellamado = false;
  //Valores para guardar series activas
  emiStatus: any;
  series: any;
  //Valores para guardar los datos del estado de la sesión actual
  listGetEdoSessions: any;
  sesion: any = {};
  tpoEspOfi: any;
  tpoEspEsc: any;
  //Valores para controlar el tiempo de llamado de un turno
  tLlamado: any;
  tLlamadoActual: any;
  //Valores que se obtienen al pedir turno
  turno: any = {};
  turnoActual: any;
  tpoEspera: any;
  turnoMostrar: any;
  //Valores que almacenan la respuesta del inicio de atención de un turno
  listaTurnoProceso: any;
  //Valores que almacenan la respuesta del final de atención de un turno
  listaCierreTurnos: any;
  //Valores para controlar el tiempo de atención de un turno
  tInicioTurno: number = 0;
  tTurno: any;
  tiempoTurno: any = "00:00:00";
  //Valores para controlar la anulación automática de un turno
  tInicioAnulacionA: any;
  tAnulacionActual:any;
  //Valores que almacenan la respuesta del cierre de sesión
  resultadoCierre: any;
  dataCierre: any;
  fin = false;
  logo: any;
  error = false;
  onlineEvent!: Observable<Event>;
  offlineEvent!: Observable<Event>;
  subscriptions: Subscription[] = [];
  intervaloEspera: any;
  intervaloActualizar: any;
  intervaloAnulacion: any;
  connectionStatus: string = 'online';
  consuOK = true;
  responsiveSubscription!: Subscription;
  Breakpoints = Breakpoints;
  currentBreakpoint:string = '';
  intentos: number = 0;
  tiempoAnulacion = 15000;
  parametros:any;
  modalPausa: boolean = false;
  showModalEdit: boolean = false;
  llamadoPaciente: boolean = false;
  showModalLlamadoPaciente: boolean = false;
  readonly breakpoint$ = this.breakpointObserver
    .observe([Breakpoints.TabletPortrait, Breakpoints.HandsetLandscape, Breakpoints.HandsetPortrait, CustomTabletPortrait])
    .pipe(
      tap((value: any) => console.log(value)),
      distinctUntilChanged()
    );
  //variables para esconder info
  hide_phone: string[] = API_ENDPOINT.clients.hide_phone;
  //modal para actualizar datos de usuario
  showModalDatosUsuario: boolean = false;
  datosUsuarioModalEvent: Subscription = new Subscription();

  constructor(
    private renderer: Renderer2,
    private servicios: ServicesService,
    private estados: EstadosService,
    private turnos: TurnosService,
    private timerService: TimersService,
    private config: ConfigService,
    private authService: AuthService,
    private aesService: AesService,
    private sweetAlertService: SweetAlertService,
    private modalService: ModalService,
    private emit: EmitService,
    private counter: CountersService,
    private localSecureService: LocalService,
    private formatoRut: FormatoRutService,
    private router: Router,
    private atencion: AtencionService,
    private desencripta: DecryptService,
    private imagenes: ImagesService,
    private colores: ColoresService,
    private clipboardService: ClipboardService,
    private rutService: RutService,
    private notificacion: NotificacionService,
    private breakpointObserver: BreakpointObserver
  ) { }

  ngOnInit(): void {
    this.escritorio = this.localSecureService.getValue('escritorio');
    this.customer = this.localSecureService.getValue('customer');
    this.parametros = this.localSecureService.getValue('parametros');
    this.renderer.removeClass(document.body, 'background-login');
    this.renderer.addClass(document.body, 'background-consultora');
    this.showModalEdit = this.checkEdit();
    this.obtenerLogo(this.customer.slug);
    this.colores.estilos(this.localSecureService.getValue('valores'));
    this.valoresConfig();
    this.obtieneData();
    this.getSeries();
    this.getEdoSession();
    this.actualizar();
    this.breakpoint$.subscribe(() =>
      this.breakpointChanged()
    );

    if(this.parametros.fllamadop) {
      this.llamadoPaciente = true;
    }
  }

  ngOnDestroy(): void {
    /* if (!this.fin) {
      this.cerrarSesion();
    }; */
    this.finActualizar(false);
    if(this.customer.slug == 'ttp_bchile' || this.customer.slug == 'ttp_bancodechile'){
      if(this.intervaloAnulacion){
        clearInterval(this.intervaloAnulacion);
      }
    }
    this.suscripcion.unsubscribe();
    try{ this.datosUsuarioModalEvent.unsubscribe(); } catch(error) {}
  }

  private breakpointChanged() {
    if(this.breakpointObserver.isMatched(Breakpoints.TabletPortrait)||this.breakpointObserver.isMatched(CustomTabletPortrait)) {
      this.currentBreakpoint = Breakpoints.TabletPortrait;
    } else if(this.breakpointObserver.isMatched(Breakpoints.HandsetLandscape)) {
      this.currentBreakpoint = Breakpoints.HandsetLandscape;
    } else if(this.breakpointObserver.isMatched(Breakpoints.HandsetPortrait)) {
      this.currentBreakpoint = Breakpoints.HandsetPortrait;
    } else {
      this.currentBreakpoint = 'Normal';
    }
  }

  async obtenerLogo(slug: string) {
    this.logo = await this.imagenes.getLogo(slug);
  }

  /* Obtiene los valores de configuración correspondiente a ese cliente */
  async valoresConfig() {
    //const config = await this.config.getConfig();
    this.tInicioLlamado = API_ENDPOINT.tLlamado;
    this.esperando = API_ENDPOINT.tEspera;
    this.version = API_ENDPOINT.version;

  }

  /* Obtiene las series correspondiente a esa oficina */
  async getSeries() {
    const idOficina = this.escritorio.idOficina;
    await this.estados.getSeries(idOficina).then((data) => {
      const emiStatus: any = data;
      this.emiStatus = emiStatus.getSeriesaDerivar;
    });
    this.series = this.emiStatus.length;
  }

  async login() {
    if(this.intentos >= 2) {
      this.sweetAlertService.swalClose();
      this.router.navigate([this.customer.slug, 'login']);
      return;
    }

    this.intentos++;
    const data = this.localSecureService.getValue('dataLogin') ?? null;
    if(!data) { this.router.navigate([this.customer.slug, 'login']); return; }

    //si existe la data y mandamos a iniciar sesión nuevamente
    this.sweetAlertService.swalLoading();
    let response: any = this.customer.slug === 'ttp_bchile'
    ? await this.authService.loginCl(data)
    : await this.authService.login(data);

    if(((!response.status || response.code != 200) && this.customer.slug === 'ttp_bchile') ||
      (!response.info && this.customer.slug !== 'ttp_bchile')) {
      this.sweetAlertService.swalClose();
      this.sweetAlertService.swal500();
      return;
    }

    response = this.customer.slug === 'ttp_bchile' ? this.aesService.aesDecrypt(response.data) : response;
    //ahora debo evaluar la respuesta
    if(!response.listalogin || !response.info) {
      this.sweetAlertService.swalClose();
      await this.sweetAlertService.swal500();
      this.router.navigate([this.customer.slug, 'login']);
      return;
    }

    //login exitoso
    switch (response.listalogin[0].coderror) {
      case 0:
        this.sweetAlertService.swalClose();
        this.getEdoSession();
        break;
      default:
        this.sweetAlertService.swalClose();
        this.sweetAlertService.swalErrorLogin('¡Lo sentimos!', 'Ha ocurrido un error de autenticación',response.listalogin[0].msg);
        this.router.navigate([this.customer.slug, 'login']);
        break;
    }
  }

  /* Obtiene el estado de la sesión actual */
  async getEdoSession(tipo: string = '') {

    const data = {
      "idOficina": this.escritorio.idOficina,
      "idEscritorio": this.escritorio.idEscritorio
    };
    if (navigator.onLine) {
      await this.estados.listaGetEdoSessions(data).then((data) => {
        this.listGetEdoSessions = data;
        if (this.listGetEdoSessions.info) {
          this.error = false;
          this.consuOK = true;
          this.localSecureService.setValue('consultora', true);
          this.sesion = this.listGetEdoSessions.listaGetEdoSessions[0];
          if (this.escritorio.idEjecutivo == this.sesion.idEje) {
            this.tpoEspOfi = this.timerService.transform(this.sesion.tespOfi);
            this.tpoEspEsc = this.timerService.transform(this.sesion.tespEsc);
            this.turnoMostrar = this.sesion.turno;
            this.acciones();
            this.sweetAlertService.swalClose();
          } else {
            this.sweetAlertService.swalClose();
            this.sweetAlertService.swalErrorLogin(
              '¡Lo sentimos!',
              'Ha ocurrido un error de autenticación',
              'Ejecutivo no conectado');
            this.router.navigate([this.customer.slug, 'login']);
          }
        } else {
          this.consuOK = false;
          this.localSecureService.setValue('consultora', false);
          setTimeout(() => {
            this.sweetAlertService.swalClose();
            this.getEdoSession();
          }, 2000);
        }
      });
    } else {
      /* this.sweetAlertService.swalClose();
      this.mostrarModalOffline('sesion'); */
      this.consuOK = false;
      this.localSecureService.setValue('consultora', false);
      setTimeout(() => {
        this.sweetAlertService.swalClose();
        this.getEdoSession();
      }, 2000);
    }

  }

  /* Indica las acciones a ejecutar de acuerdo al estado de la sesión actual */
  acciones() {
    switch (this.sesion.estado) {
      case "I":
        this.tLlamadoActual = this.timerService.transform(0);
        this.turno.serie = '---';
        break;
      case "F":
        this.login();
        break;
      case "P":
        this.sweetAlertService.swalClose();
        this.mostrarModalPausa();
        this.turno.serie = '---';
        break;
    }
    switch (this.sesion.detalle) {
      case "En espera":
        this.tLlamadoActual = this.timerService.transform(0);
        this.turno.serie = '---';
        if (this.sesion.qespEsc > 0) {
          this.pedirTurno();
        } else {
          this.inicioTEspera();
        }
        break;
      case "Llamando":
        //this.inicioTLlamado();
        if(this.customer.slug == 'ttp_bchile' || this.customer.slug == 'ttp_bancodechile'){
          this.inicioTAnulacionA();
        }
        if(Object.keys(this.turno).length > 0){
          if (this.turno.estado != "LLA") {
            this.pedirTurno();
          }
        }  else {
          this.turno = this.localSecureService.getValue('turno');
        }

        break;
      case "Atendiendo":
        //validar si se debe modificar rut
        this.turno = this.localSecureService.getValue('turno') ?? {};
        this.tpoEspera = this.timerService.transform(0);
        this.obtenerDatosAtencion(this.sesion);
          this.finTTurno();
          this.inicioTTurno();
          if (this.turno.Turno <= 0) {
            this.obtenerDatosAtencion(this.sesion);
          }
          if (!this.turno.turno) {
            this.turno = this.localSecureService.getValue('turno');
            //this.tLlamadoActual = this.localSecureService.getValue('con-tllamado');
            if (this.turno.turno) {
              this.tpoEspera = this.turno.tpoEsp
                ? this.timerService.transform(this.turno.tpoEsp)
                : this.timerService.transform(this.turno.tEsp);
            } else {
              this.obtenerDatosAtencion(this.sesion);
            }
          }
        // }
        break;
    }
  }

  obtenerDatosAtencion(sesion: any) {
    this.turno.idSerie = this.sesion.idSerie;
    this.obtenerNombreSerie();
    this.turno.letra = this.sesion.letra;
    this.turno.turno = this.sesion.turno;
    // if (!this.tpoEspera) {
    //   this.tpoEspera = 'No disponible';
    // }
    if (!this.tpoEspera) { this.tpoEspera = this.turno.tesp >= 0 ? this.timerService.transform(this.turno.tesp) : 'No disponible'; }

    let tiempo: number = 0;
    try { tiempo = parseInt(this.localSecureService.getValue('tllamado')) } catch (err) { }

    this.tLlamadoActual = this.timerService.transform(tiempo);
    this.turno.cliente = this.turno.cliente ? this.turno.cliente : 'No disponible';
    this.turno.rut = this.turno.rut ? this.turno.rut : 'No disponible';
    this.turno.fono = this.turno.fono ? this.turno.fono : 'No disponible';

    //abrir modal para editar turno
    // if (!this.showModalDatosUsuario && (this.turno.rut === '' || this.turno.rut === 'No disponible')) {
    //   this.showModalDatosUsuario = true;
    //   this.mostrarModalDatosUsuario();
    //   this.datosUsuarioModalEvent =
    //   this.modalService.modalRef?.content.event.subscribe(async (data: any) => {
    //     if (data) {
    //       const turno = this.localSecureService.getValue('turno');
    //       if (turno) {
    //         turno.cliente = data.cliente == "" || data.cliente == null ? 'No disponible' : data.cliente;
    //         turno.rut = data.rut;
    //         this.turno.cliente = data.cliente == "" || data.cliente == null ? 'No disponible' : data.cliente;
    //         this.turno.rut = data.rut;

    //         this.localSecureService.setValue('turno', turno);
    //       }
    //     }

    //     this.showModalDatosUsuario = false;
    //     this.datosUsuarioModalEvent.unsubscribe();
    //   });
    // }
  }

  

  obtenerNombreSerie() {
    for (let index = 0; index < this.series; index++) {
      if (this.turno.idSerie == this.emiStatus[index].idSerie) {
        this.turno.serie = this.emiStatus[index].serie;
      }
    }
  }

  /* Controla el tiempo de llamado de un turno */
  inicioTLlamado(tInicioLlamado = this.tInicioLlamado) {
    this.tLlamado = setInterval(() => {
      tInicioLlamado--;
      this.tLlamadoActual = this.timerService.transform(tInicioLlamado);
      if (tInicioLlamado === 0) {
        this.finTLlamado();
        this.mostrarModalAnulacion();

        /*  */
      }
    }, 1000)
  }

  finTLlamado() {
    clearInterval(this.tLlamado);
    this.localSecureService.setValue('tllamado', this.tLlamadoActual);
  }

  inicioTEspera(esperando = this.esperando) {
    //this.counter.inicioEspera(this.esperando);
    this.intervaloEspera = setInterval(() => {
      esperando--;
      if (esperando === 0) {
        this.finEspera();
        this.getEdoSession();
      }
    }, 1000);
  }

  finEspera() {
    clearInterval(this.intervaloEspera);
  }

  inicioTAnulacionA() {
    let tInicioAnulacionA = this.parametros?.TAnulacion ?  this.parametros?.TAnulacion : 15
    this.intervaloAnulacion = setInterval(() => {
      tInicioAnulacionA--;
      this.tAnulacionActual = this.timerService.transform(tInicioAnulacionA);
      if (tInicioAnulacionA === 0) {
        clearInterval(this.intervaloAnulacion);
        this.iniciarAtencion('A');

        /*  */
      }
    }, 1000)
  }

  /* Pide los turnos pendientes en esa oficina */
  async pedirTurno(pausa = false) {
    //validar si la consultora esta operativa para realizar peticiones
    if(!this.consuOK) {
      this.sweetAlertService.swalClose();
      this.sweetAlertService.swalInternet();
      return;
    }

    if (this.sesion.estado == 'I') {
      this.sweetAlertService.swalLoading();
    }
    const data = {
      "idOficina": this.escritorio.idOficina,
      "idEscritorio": this.escritorio.idEscritorio,
      "idEjecutivo": this.escritorio.idEjecutivo
    };
    try {

    await this.turnos.pedirTurno(data).then((data: any) => {
      this.turnoActual = data;
      if (this.turnoActual.info) {
        this.turno = this.turnoActual.listaturno[0];
        this.consuOK = true;
        this.localSecureService.setValue('consultora', true);
        switch (this.turno.coderror) {
          case 1:
            this.tLlamadoActual = this.timerService.transform(0);
            this.turno.serie = '---';
            this.inicioTEspera();
            break;
          case 2:
            this.sweetAlertService.swalErrorLogin(
              '¡Lo sentimos!',
              'Ha ocurrido un error de autenticación',
              this.turno.msg);
            this.router.navigate([this.customer.slug, 'login']);
            break;
          default:
            this.turno.rut = this.customer.slug!='ttp_clinicaferrer' ? this.formatoRut.formatearRut(this.turno.rut) : this.turno.rut;
            this.turno.cliente = this.turno.cliente ? this.turno.cliente : 'No disponible';

            if (this.customer.slug=="ttp_bchile") {
              let imagen = '';
              try{
                 imagen = JSON.parse(this.turno.telefono).imagen;
              }
              catch(e){
                this.turno.foto = `https://controlacceso.totalpack.cl/images/bchile/foto/${this.turno.telefono}`
              }
              this.turno.foto = `${imagen}`
            }
            //actualizara turno en variable cache
            this.localSecureService.setValue('turno', this.turno);

            if (navigator.userAgent.indexOf('Chrome') !== -1 && !(navigator.userAgent.indexOf('Android') !== -1)) {
              this.notificacion.showNotification(this.turno.turno, this.turno.letra);
            }
            this.tpoEspera = this.timerService.transform(this.turno.tpoesp);
            if (this.sesion.detalle != "Llamando" || pausa) {
              this.getEdoSession();
            }
            break;
        }

      } else {
        this.sweetAlertService.swalClose();
        this.error = true;
        this.consuOK = false;
        this.localSecureService.setValue('consultora', false);
        setTimeout(() => {
          this.sweetAlertService.swalLoading();
          this.getEdoSession();
        }, 2000);
        //this.mostrarModalError();
      }
    });

  } catch(error) {
    this.sweetAlertService.swalClose();
    this.consuOK = false;
    this.localSecureService.setValue('consultora', false);
  }
  }

  /* Inicia atención de un turno */
  async iniciarAtencion(tipo: string = '', reanudarConUrgencia = false) {
    this.sweetAlertService.swalClose();
    //validar si la consultora esta operativa para realizar peticiones
    if(!this.consuOK) {
      this.sweetAlertService.swalInternet();
      return;
    }

    if(this.customer.slug == 'ttp_bchile' || this.customer.slug == 'ttp_bancodechile'){
      if(this.intervaloAnulacion){
        clearInterval(this.intervaloAnulacion);
      }
    }

    let verifica: any;
    await this.getSession().then((data) => { verifica = data; });
    if (verifica.listaGetEdoSessions[0].estado == 'F') {
      this.sweetAlertService.swalClose();
      this.modalService.closeModal();
      this.sweetAlertService.swalErrorLogin(
        '¡Lo sentimos!',
        'Ha ocurrido un error de autenticación',
        "Ejecutivo no conectado");
      this.router.navigate([this.customer.slug, 'login']);
    } else {
      this.iniciar(tipo,reanudarConUrgencia);
      this.rellamado = true;
      setTimeout(() => {
        this.rellamado = false;
      }, 5000);
    }

  }

  async iniciar(tipo: string, reanudarConUrgencia = false) {
    this.sweetAlertService.swalLoading();
    this.copiar();
    const origen = this.turno.origen;
    const turno = {
      "idOficina": this.escritorio['idOficina'],
      "idEscritorio": this.escritorio['idEscritorio'],
      "idEjecutivo": this.escritorio['idEjecutivo'],
      "idSerie": this.turno.idSerie,
      "turno": this.turno.turno,
      "tipo": tipo
    }
    await this.turnos.iniciaTurno(turno).then((data) => {
      this.listaTurnoProceso = data;

    });
    if (this.listaTurnoProceso.info) {
      this.turno = this.listaTurnoProceso.listaturnoproceso[0];
      this.consuOK = true;
      this.localSecureService.setValue('consultora', true);
      this.obtenerNombreSerie();
      this.turno.rut = this.customer.slug!='ttp_clinicaferrer' ? this.formatoRut.formatearRut(this.turno.rut) : this.turno.rut;
      //debo iniciar el timer del tiempo de atención
      if(tipo === 'U'){ this.inicioTTurno(); }

      if (this.customer.slug=="ttp_bchile") {
        let imagen = '';
        try{
           imagen = JSON.parse(this.turno.telefono).imagen;
        }
        catch(e){
          this.turno.foto = `https://controlacceso.totalpack.cl/images/bchile/foto/${this.turno.telefono}`
        }
        this.turno.foto = `${imagen}`
      }
      this.localSecureService.setValue('motivos', JSON.parse(this.turno.motivoLista));
      if (tipo == 'A') {
        this.anularLlamado('Solicitado');
      }
      switch (this.turno.coderror) {
        case 4003:
          this.turno.origen = origen;
          this.localSecureService.setValue('turno', this.turno);
          this.tpoEspera = this.timerService.transform(this.turno.tesp);
          if(!reanudarConUrgencia){
            if (this.sesion.estado == 'I') {
              this.pedirTurno()
            } else {
              this.finTLlamado();
              this.getEdoSession();
            }
          } else {
            this.pedirTurno(true)
          }
          break;
        case 4004:
         const resp:any= await this.sweetAlertService.swalError(
            '¡No se puede realizar la atención de urgencia!',
            this.turno.msg,
            'Verifique el número del turno e inténtelo nuevamente');
            if(this.sesion.estado == 'P'){
              this.sweetAlertService.swalClose();
              this.getEdoSession();
            }
          break;
        default:
          if(!reanudarConUrgencia){
            if (this.sesion.estado == 'I' ) {
              this.pedirTurno()
            } else {
              this.turno.origen = origen;
              this.localSecureService.setValue('turno', this.turno);
              this.finTLlamado();
              this.getEdoSession();
            }
          } else {
            this.pedirTurno(true)
          }
          break;
      }
    } else {
      this.sweetAlertService.swalClose();
      this.error = true;
      this.consuOK = false;
      this.localSecureService.setValue('consultora', false);
      setTimeout(() => {
        this.sweetAlertService.swalLoading();
        this.getEdoSession();
      }, 2000);
      //this.mostrarModalError();

    }

  }

  /* Termina atención de un turno */
  async terminarAtencion(cierre: boolean = false) {
    this.sweetAlertService.swalLoading();
    this.finTTurno();
    const dataFin = {
      "idTurno": this.turno.idTurno,
      "idOficina": this.escritorio['idOficina'],
      "listamotivos": this.localSecureService.getValue('motivosTurno').listaMotivos,
      "observaciones": this.localSecureService.getValue('motivosTurno').observaciones,
      "fpidoturno": cierre ? 0 : 1
    }
    await this.turnos.cierraTurno(dataFin).then((data: any) => {
      if (data.error == true) {
        this.sweetAlertService.swalClose();
        this.error = true;
        this.consuOK = false;
        this.localSecureService.setValue('consultora', false);
        setTimeout(() => {
          this.sweetAlertService.swalLoading();
          this.getEdoSession();
          //this.terminarAtencion(cierre);
        }, 2000);
        //this.mostrarModalError();
      } else {
        this.consuOK = true;
        this.localSecureService.setValue('consultora', true);
        this.sweetAlertService.swalClose();
        const respFinTurno = JSON.parse(data[0].ateEnd);
        this.sesion = JSON.parse(data[0].conStatus);
        this.turno = JSON.parse(data[0].pidoturno);

        switch (this.turno.coderror) {
          case 1:
            this.tLlamadoActual = this.timerService.transform(0);
            this.turno.serie = '---';
            this.inicioTEspera();
            break;
          case 2:
            this.sweetAlertService.swalErrorLogin(
              '¡Lo sentimos!',
              'Ha ocurrido un error de autenticación',
              this.turno.msg);
            this.router.navigate([this.customer.slug, 'login']);
            break;
          default:
            if (!cierre) {
              this.turno.rut = this.customer.slug!='ttp_clinicaferrer' ? this.formatoRut.formatearRut(this.turno.rut) : this.turno.rut;
              this.localSecureService.setValue('turno', this.turno);
              if (navigator.userAgent.indexOf('Chrome') !== -1 && !(navigator.userAgent.indexOf('Android') !== -1)) {
                this.notificacion.showNotification(this.turno.turno, this.turno.letra);
              }
              this.tpoEspera = this.timerService.transform(this.turno.tpoesp);
              /* if (this.sesion.detalle != "Llamando") {
                this.acciones();
              } */
              this.acciones();
              break;
            } else {
              this.finSession(this.dataCierre);
            }

        }
      }

      //this.sweetAlertService.swalClose();
    })
    /* await this.terminarTurno(dataFin);
    if (this.listaCierreTurnos.info) {
      if (!cierre) {
        this.pedirTurno();
      } else {
        this.finSession(this.dataCierre);
      }
    } else {

    } */
  }

  async terminarTurno(dataFin: any) {
    await this.turnos.finTurno(dataFin).then((data) => {
      this.listaCierreTurnos = data;
    });

  }

  /* Contador del tiempo del turno */
  inicioTTurno() {
    //finaliza el timer antes de crearlo nuevamente
    if(this.tTurno){ this.finTTurno(); }

    //inicia el contador
    this.tInicioTurno = this.sesion.tpoAtencion;
    this.tTurno = setInterval(() => {
      //si el tiempo manejado hasta ahora es menor al que detecta nuevamente la sesión se reemplaza
      if(this.tInicioTurno < this.sesion.tpoAtencion) { this.tInicioTurno = this.sesion.tpoAtencion }
      this.tInicioTurno++;
      this.tiempoTurno = this.timerService.transform(this.tInicioTurno);
    }, 1000);
  }

  finTTurno() {
    clearInterval(this.tTurno);
    this.tInicioTurno = 0;
    this.tiempoTurno = this.timerService.transform(this.tInicioTurno);
  }

  /* Cerrar la sesión del ejecutivo */
  cerrarSesion() {
    this.dataCierre = {
      "idOficina": this.escritorio['idOficina'],
      "idEscritorio": this.escritorio['idEscritorio'],
      "idEjecutivo": this.escritorio['idEjecutivo']
    };
    switch (this.sesion.detalle) {
      case "En espera":
        this.finEspera();
        this.finSession(this.dataCierre);
        break;
      case "Llamando":
        this.anulaLLamado();
        this.finSession(this.dataCierre);
        break;
      case "Atendiendo":
        this.verMotivos(true, false, false)
        break;
      default:
        this.finSession(this.dataCierre);
        break;
    }
  }

  async finSession(dataCierre: any) {
    /* if (navigator.onLine) { */
    await this.servicios.logOff(dataCierre).then((data) => {
      this.resultadoCierre = data;
    });
    this.sweetAlertService.swalClose();
    if (this.resultadoCierre) {
      this.fin = true;
      this.finActualizar(false);
      this.router.navigate([this.customer.slug, 'login']);
    } else {
      this.sweetAlertService.swal500();
    }
    /* } else {
      this.sweetAlertService.swalClose();
      this.mostrarModalOffline('cerrar');
    } */

  }

  /* Hacer rellamado de un turno */
  rellamar() {
     //validar si la consultora esta operativa para realizar peticiones
     if(!this.consuOK) {
      this.sweetAlertService.swalClose();
      this.sweetAlertService.swalInternet();
      return;
    }

    this.finTLlamado();
    this.pedirTurno();
    if(this.customer.slug == 'ttp_bchile' || this.customer.slug == 'ttp_bancodechile'){
    clearInterval(this.intervaloAnulacion);
    this.inicioTAnulacionA();
    this.rellamado = true;
    setTimeout(() => {
      this.rellamado = false;
    }, 3000);
    } else {
      //this.inicioTLlamado();
    this.sweetAlertService.swalRellamar(this.escritorio.ejecutivo);
    this.rellamado = true;
    setTimeout(() => {
      this.rellamado = false;
    }, 10000);
    }
  }

  /* Mensaje para no pausar cuando se está inactivo */
  pausaInactivo() {
    this.sweetAlertService.swalError(
      '¡No puede realizar Pausa!',
      'Aún no ha iniciado la atención de turnos',
      'Ya se encuentra en pausa. Utilice el botón "INICIAR LLAMADOS" para despausar y comenzar la atención')
  }

  /* Mensaje paracuando se anula un turno que se esta llamando */
  anularLlamado(razon: string) {
    let subTitle = '';
    switch (razon) {
      case 'Agotado': subTitle = 'Se ha agotado el tiempo de llamado';
        break;
      case 'Solicitado': subTitle = 'Ha solicitado la anulación del llamado';
        break;
    }
    this.sweetAlertService.swalAnular(subTitle)
  }

  /* Determina las acciones a realizar luego de cerrar modales */
  obtieneData() {
    this.suscripcion = this.emit.data.subscribe(data => {
      switch (data) {
        case 'continuar': this.modalPausa = false; this.pedirTurno(true);
          break;
        case 'cerrar': this.modalPausa = false; this.cerrarSesion();
          break;
        case 'sesion': this.getEdoSession();
          break;
        case 'finTLlamado': this.finTLlamado(); this.getEdoSession();
          break;
        case 'finTTurno': this.finTTurno(); this.getEdoSession();
          break;
        case 'finAtencion': this.verMotivos(false, false, false);
          break;
        case 'pausa': this.mostrarModalMotivosPausa('derivar');
          break;
        case 'cierreDeriva': this.mostrarModalCerrar('derivar');
          break;
        case 'failPausa':
          this.sweetAlertService.swalClose();
          this.error = true;
          this.consuOK = false;
          this.localSecureService.setValue('consultora', false);
          setTimeout(() => {
            this.sweetAlertService.swalLoading();
            this.getEdoSession();
          }, 2000);
          //this.mostrarModalError();
          break;
        case 'cierraPausa':
          //this.inicioTLlamado(this.tLlamadoActual.slice(6, 8));
          break;
        case 'anular': this.iniciarAtencion('A'); this.anularLlamado('Agotado');
          break;
        case 'rellamar':
          //this.inicioTLlamado();
          break;
        case 'finTurno': this.terminarAtencion();
          break;
        case 'finTurnoSesion': this.terminarAtencion(true);
          break;
        case 'finTTurnoPausa': this.verMotivos(false, true, false);
          break;
        case 'urgencia': this.iniciarAtencion('U');
          break;
        case 'iniciar': this.iniciarAtencion(this.localSecureService.getValue('tipo'));
          break;
        case 'terminarTurno': this.terminarTurno(this.localSecureService.getValue('dataFin'));
          break;
        case 'noPausa': this.sweetAlertService.swalClose(); this.mostrarModalOffline('sesion');;
          break;
        case 'motivos': this.verMotivos(
          this.localSecureService.getValue('cierre'),
          this.localSecureService.getValue('pausa'),
          this.localSecureService.getValue('urgencia'));
          break;
        case 'continuarUrgencia':
          this.modalPausa = false; this.mostrarModalExcepcion(true);
          break;
        default:
          this.turno.idSerie = data.idSerie;
          this.turno.turno = data.numTurno;
          this.tLlamadoActual = this.timerService.transform(0);
          switch (this.sesion.detalle) {
            case 'Atendiendo': this.verMotivos(false, false, true);
              break;
            default: {
              if(data.reanudar){
                this.iniciarAtencion('U',true)
              } else {
                this.iniciarAtencion('U')
              }
            };
              break;
          };
          break;
      }
    });
  }

  /* Muestran modales segun cada caso */
  mostrarModalMotivosPausa(tipo: string = 'normal'): void {
    //validar si la consultora esta operativa para realizar peticiones
    if(!this.consuOK) {
      this.sweetAlertService.swalClose();
      this.sweetAlertService.swalInternet();
      return;
    }

    switch (this.sesion.detalle) {
      case "En espera": this.finEspera();
        break;
      case "Llamando": this.finTLlamado();
        break;
    }
    const opciones = { class: '', initialState: { detalle: this.sesion.detalle, tipo: tipo } };
    this.modalService.openModal(ModalMotivosPausaComponent, opciones);
  }

  mostrarModalPausa(): void {
    if(!this.modalPausa) {
      this.modalPausa = true;
      const opciones = { class: '', initialState: {} };
      this.modalService.openModal(ModalPausaComponent, opciones);
    }
  }

  mostrarModalExcepcion(reanudar = false): void {
    this.sweetAlertService.swalClose();
     //validar si la consultora esta operativa para realizar peticiones
     if(!this.consuOK) {
      this.sweetAlertService.swalInternet();
      return;
    }

    switch (this.sesion.detalle) {
      case "En espera":
      // this.finEspera();
        break;
      case "Llamando": this.finTLlamado();
        break;
    }
    const opciones = { class: 'modal-lg', initialState: { detalle: this.sesion.detalle, reanudar } };
    this.modalService.openModal(ModalExcepcionFilaComponent, opciones);
  }

  mostrarModalCerrar(tipo: string = 'normal'): void {
    //validar si la consultora esta operativa para realizar peticiones
    if(!this.consuOK) {
      this.sweetAlertService.swalClose();
      this.sweetAlertService.swalInternet();
      return;
    }

    const opciones = { class: '', initialState: { tipo: tipo } };
    this.modalService.openModal(ModalCerrarSesionComponent, opciones);
  }

  mostrarModalDerivar(idTurno: string, idSerie: number): void {
     //validar si la consultora esta operativa para realizar peticiones
     if(!this.consuOK) {
      this.sweetAlertService.swalClose();
      this.sweetAlertService.swalInternet();
      return;
    }

    const opciones = { class: '', initialState: { idTurno: idTurno, serieActual: idSerie } };
    this.modalService.openModal(ModalDerivarAtencionComponent, opciones);
  }

  mostrarModalAtencionRemota(idTurno: string, ejecutivo: string): void {
    //validar si la consultora esta operativa para realizar peticiones
    if(!this.consuOK) {
      this.sweetAlertService.swalClose();
      this.sweetAlertService.swalInternet();
      return;
    }

    const opciones = { class: 'modal-lg', initialState: { idTurno: idTurno, ejecutivo: ejecutivo } };
    this.modalService.openModal(ModalAtencionRemotaComponent, opciones);
  }

  mostrarModalAnulacion() {
    //validar si la consultora esta operativa para realizar peticiones
    if(!this.consuOK) {
      this.sweetAlertService.swalClose();
      this.sweetAlertService.swalInternet();
      return;
    }

    const opciones = { class: '', initialState: {} };
    this.modalService.openModal(ModalAnulacionComponent, opciones);
  }

  mostrarModalError() {
     //validar si la consultora esta operativa para realizar peticiones
     if(!this.consuOK) {
      this.sweetAlertService.swalClose();
      this.sweetAlertService.swalInternet();
      return;
    }

    const opciones = { class: '', initialState: {} };
    this.modalService.openModal(ModalErrorComponent, opciones);
  }

  mostrarModalOffline(viene: string) {
    const opciones = { class: '', initialState: { viene: viene } };
    this.modalService.openModal(ModalOfflineComponent, opciones);
  }

  mostrarModalMotivosAtencion(listaMotivos: any, idTurno: string, cierre: boolean, pausa: boolean, urgencia: boolean): void {
    //validar si la consultora esta operativa para realizar peticiones
    if(!this.consuOK) {
      this.sweetAlertService.swalClose();
      this.sweetAlertService.swalInternet();
      return;
    }

    const opciones = { class: '', initialState: { checkboxes: listaMotivos, idTurno: idTurno, cierre: cierre, pausa: pausa, urgencia: urgencia } };
    this.modalService.openModal(ModalMotivosAtencionComponent, opciones);
  }

  mostrarModalMotivosAtencionClaro(listaMotivos: any, idTurno: string, cierre: boolean, pausa: boolean, urgencia: boolean): void {
    const opciones = {
      class: '',
      initialState: {
        listamotivos: listaMotivos,
        idTurno: idTurno,
        cierre: cierre,
        pausa: pausa,
        urgencia: urgencia
      }
    };
    this.modalService.openModal(ModalMotivosAtencionClaroComponent, opciones);
  }


  errorComunicacion() {
    this.sweetAlertService.swalError(
      '¡Error de comunicación!',
      'Ha ocurrido una falla al intentar conectarse con nuestros servidores',
      'Espere unos momentos e intente realizar su solicitud nuevamente')
  }


  /* Inicia atención de un turno */
  async anulaLLamado() {
    this.sweetAlertService.swalLoading();
    const turno = {
      "idOficina": this.escritorio['idOficina'],
      "idEscritorio": this.escritorio['idEscritorio'],
      "idEjecutivo": this.escritorio['idEjecutivo'],
      "idSerie": this.turno.idSerie,
      "turno": this.turno.turno,
      "tipo": 'A'
    }
    await this.turnos.iniciaTurno(turno).then((data: any) => {
      if (data.info) {
        this.finTLlamado();
      }
    });
  }

  async getSession() {
    if(!navigator.onLine) {
      this.consuOK = false;
      this.localSecureService.setValue('consultora', false);
      return false;
    }

    try {
      const data = {
        "idOficina": this.escritorio.idOficina,
        "idEscritorio": this.escritorio.idEscritorio
      };
      const response: any = await this.estados.listaGetEdoSessions(data);
      if(!response.listaGetEdoSessions) {
        this.consuOK = false;
        this.localSecureService.setValue('consultora', false);
        return false;
      }

      return response;
    } catch(error) {
      this.consuOK = false;
      this.localSecureService.setValue('consultora', false);
      return false;
    }
  }

  async verMotivos(cierre: boolean, pausa: boolean, urgencia: boolean) {
    this.sweetAlertService.swalClose();
    //validar si la consultora esta operativa para realizar peticiones
    if(!this.consuOK) {
     this.sweetAlertService.swalInternet();
     return;
   }

    this.localSecureService.setValue('cierre', cierre);
    this.localSecureService.setValue('pausa', pausa);
    this.localSecureService.setValue('urgencia', urgencia);
    const listaMotivos = this.localSecureService.getValue('motivos');
    if (listaMotivos[0].IdSerie) {
      const motivos = listaMotivos.map((valor: any) => {
        const motivo = {
          idMotivo: valor.IdMotivo,
          motivo: valor.Motivo
        };
        return motivo;
      });
      if (this.customer.slug == "ttp_claro") {
        this.mostrarModalMotivosAtencionClaro(motivos, this.turno.idTurno, cierre, pausa, urgencia);
      } else {
        this.mostrarModalMotivosAtencion(motivos, this.turno.idTurno, cierre, pausa, urgencia);
      }
    } else {
      const motivosTurno = {
        listaMotivos: '',
        observaciones: ''
      }
      this.localSecureService.setValue('motivosTurno', motivosTurno);
      if (pausa) {
        this.finTTurno();
        this.getEdoSession();
      } else {
        if (urgencia) {
          this.iniciarAtencion('U');
        } else {
          this.terminarAtencion(cierre);
        }
      }
    };

  }

  copiar() {
    if (this.turno.rut) {
      const rut = this.turno.rut.replace(/\./g, '');

      if (this.customer.slug == 'ttp_alemana') {
        const rutValidar = this.turno.rut.replace(/\./g, '').replace('-', '');
        const validado = this.rutService.validarRut(rutValidar);
        let opt = 0;
        if (validado) {
          opt = 1;
        } else {
          opt = 2;
        }
        const xml = '<?xml version="1.0" encoding="UTF-8"?><paciente><NumDocto>'
          + rut
          + '</NumDocto><TipoDocto>'
          + opt
          + '</TipoDocto></paciente>'
        this.clipboardService.copy(xml);
      } else {
        this.clipboardService.copy(rut);
      }
    }
  }

  actualizar(esperando = 5) {
    this.intervaloActualizar = setInterval(async () => {
      esperando--;

      if (esperando <= 0) {
        if (this.sesion.detalle != "En espera") {
          const sesion: any = await this.getSession();
          if(!sesion) { this.finActualizar(true); return; }
          this.consuOK = true;
          this.localSecureService.setValue('consultora', true);
          this.sesion.qEspOfi = sesion.listaGetEdoSessions[0].qEspOfi;
          this.sesion.qespEsc = sesion.listaGetEdoSessions[0].qespEsc;
          this.tpoEspOfi = this.timerService.transform(sesion.listaGetEdoSessions[0].tespOfi);
          this.tpoEspEsc = this.timerService.transform(sesion.listaGetEdoSessions[0].tespEsc);
          this.sesion.tpoAtencion = sesion.listaGetEdoSessions[0].tpoAtencion;
          this.finActualizar(true);
        } else {
          this.finActualizar(true);
        }
      }
    }, 1000);
  }

  finActualizar(sesionActiva: boolean) {
    clearInterval(this.intervaloActualizar);
    if (sesionActiva == true) {
      this.actualizar();
    }
  }

  checkEdit() {
    if(!this.parametros.solicitarDatos) { return false; }

    if(!this.parametros.solicitarDatos.nombre && !this.parametros.solicitarDatos.rut && !this.parametros.solicitarDatos.telefono) {
      return false;
    }

    return true;
  }

  mostrarModalDatosUsuario(): void {
    if (!this.showModalDatosUsuario) {
      this.showModalDatosUsuario = true;
      const opciones = { class: 'modal-lg', backdrop: true, initialState: { turno: !this.turno?.turno ? this.localSecureService.getValue('turno') : this.turno } };
      this.modalService.openModal(ModalDatosUsuarioComponent, opciones);
      this.datosUsuarioModalEvent =
      this.modalService.modalRef?.content.event.subscribe(async (data: any) => {
        if (data) {
          const turno = this.localSecureService.getValue('turno');
          if (turno) {
            turno.cliente = data.cliente == "" || data.cliente == null ? 'No disponible' : data.cliente;
            this.turno.cliente = data.cliente == "" || data.cliente == null ? 'No disponible' : data.cliente;
            turno.rut = data.rut == "" || data.rut == null ? 'No disponible' : this.formatoRut.formatearRut(data.rut);
            this.turno.rut = data.rut == "" || data.rut == null ? 'No disponible' : this.formatoRut.formatearRut(data.rut);
            turno.fono = data.fono == "" || data.fono == null ? 'No disponible' : data.fono
            this.turno.fono = data.fono == "" || data.fono == null ? 'No disponible' : data.fono;
            this.localSecureService.setValue('turno', turno);
          }
        }

        this.showModalDatosUsuario = false;
        this.datosUsuarioModalEvent.unsubscribe();
      });
    }
  }

  modalLlamadoPaciente(): void {
    if(!this.consuOK) {
      this.sweetAlertService.swalClose();
      this.sweetAlertService.swalInternet();
      return;
    }

    const opciones = { class: 'modal-lg', initialState: { slug: this.customer.slug, turno: this.turno } };
    this.modalService.openModal(ModalLlamadoPacienteComponent, opciones);
  }
}
